import { BaseComponent } from '../../base-component';
import { encodeHtml, encodeHtmlTag } from '../../_common/client/encode-html';
import { ProviderService } from './provider-service';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';
import { sheetV1 } from '@otto-ec/otto-components/sheet';

export class ManufacturerContentBtnComponent extends BaseComponent {
    public rootSelector = '.js_pdp_manufacturer-content-btn';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        this.registerClickHandler();
    }

    private registerClickHandler(): void {
        const buttonElement = this.getRootElement();
        buttonElement?.addEventListener('click', () => this.clickListener(buttonElement), false);
    }

    private async clickListener(buttonElement: HTMLElement): Promise<void> {
        const brandName = buttonElement.getAttribute('data-brand-name');
        const headlineContent = encodeHtmlTag`Weitere Artikelinformationen von ${brandName}`;
        const sheetContentElement = document.createElement('div');
        sheetContentElement.classList.add('pdp_manufacturer-content-btn-sheet__content');
        sheetContentElement.innerHTML =
            '<oc-spinner-v1 class="pdp_manufacturer-content-btn-sheet__spinner" size="200" variant="default"></oc-spinner-v1>';

        const sheetElement = await sheetV1.create({
            id: 'pdp_manufacturer-content-btn-sheet',
            fullHeight: true,
            headline: headlineContent,
            adaptiveAlignment: 'center',
            maxWidthCentered: '900px',
        });
        sheetElement.addEventListener('oc-sheet-close', () => this.closeLayerCallback(), { once: true });
        sheetElement.replaceChildren(sheetContentElement);
        sheetElement.open = true;

        try {
            const providerName = encodeHtml(buttonElement.getAttribute('data-provider-name'));
            const ean = encodeHtml(buttonElement.getAttribute('data-ean'));
            let iframeSource = '';
            iframeSource = await ProviderService.getIframeSource(providerName, ean);
            sheetContentElement.replaceChildren(this.createIframeElement(iframeSource));
        } catch (error) {
            const errorMessageHtml =
                '<oc-banner-v1 size="200" variant="error" headline="Entschuldigung!" hide-close-button>Aufgrund von ' +
                'technischen Problemen kann der Inhalt leider nicht geladen werden. Bitte versuche es zu einem ' +
                'späteren Zeitpunkt erneut.</oc-banner-v1>';

            sheetContentElement.innerHTML = errorMessageHtml;

            trackEvent({
                product_BrandContent: [error as string],
            });
        }
    }

    private closeLayerCallback(): void {
        trackEvent({
            product_BrandContent: ['close'],
        });
    }

    private createIframeElement(iframeSource: string): HTMLElement {
        const iframeElement = document.createElement('iframe');
        iframeElement.className = 'pdp_manufacturer-content-btn-sheet__iframe';
        iframeElement.onload = () => this.iframeLoadEventListener();
        iframeElement.src = iframeSource;
        return iframeElement;
    }

    private iframeLoadEventListener() {
        trackEvent({
            product_BrandContent: ['load'],
        });
    }
}
